import React from "react";
import PropTypes from "prop-types";
import { NavigatorAction } from "../../../flux";
import ReadingProgress from "./reading-progress";
import ReadingList from "./reading-list";
import { OffScreenComponent } from "../../../../../ui/components/mixins/index";
import { Button } from "@vitalsource/vstui";

export default class ReadingOverview extends React.Component {
  constructor(props) {
    super(props);
    this._startAssignment = this._startAssignment.bind(this);
  }

  componentDidMount() {
    Fraction.Helpers.Users.getUserData("allow-cookies") &&
      this.focusOnMount.focus();
    let route = window.location.hash.split("cfi")[0];
    if (route.slice(0, 2) === "#/") {
      route = route.slice(2);
    }
    Fraction.Router.setRoute(route, true);
  }

  _minimize() {
    this.props.minimize({
      route: "reading-overview"
    });
  }

  _startAssignment() {
    const reading = this.props.readings[0];
    NavigatorAction.replace("assignment-reading", {
      reading
    });
  }

  render() {
    const total = this.props.readings.length;
    const completed = this.props.readings.filter(r => r.completed_at).length;
    return (
      <div id="reading-overview">
        <div className="container">
          <div className="readings-container">
            <div className="book-header">
              <h1
                ref={header => {
                  this.focusOnMount = header;
                }}
                tabIndex={-1}
                className="assignment-title"
              >
                {this.props.assignment.title}
              </h1>
              <div className="overview-container">
                <div className="summary">
                  <ReadingProgress total={total} completed={completed} />
                  <OffScreenComponent>
                    {i18n.t("assignments.progress", { completed, total })}
                  </OffScreenComponent>
                </div>

                <div className="overview-right">
                  <p className="book-title">{this.props.book.title}</p>
                  <p className="book-author">{this.props.book.author}</p>
                  <div className="readings">
                    {this.props.readings.length > 0 && (
                      <h2>{i18n.t("assignments.readings")}</h2>
                    )}
                    <ReadingList
                      book={this.props.book}
                      assignment={this.props.assignment}
                      loading={this.props.book.isLoading}
                      readings={this.props.readings}
                    />
                    <div className="actions">
                      {total && (
                        <Button
                          label={i18n.t("assignments.start-assignment")}
                          onClick={this._startAssignment}
                        >
                          {i18n.t("assignments.start-assignment")}
                        </Button>
                      )}
                      <div className="link">
                        <Button inline href={`${window.location.origin}/#/`}>
                          {i18n.t("assignments.back-library")}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ReadingOverview.propTypes = {
  isbn: PropTypes.string.isRequired,
  book: PropTypes.object.isRequired,
  assignmentId: PropTypes.string,
  readings: PropTypes.array,
  assignment: PropTypes.object
};
